// React
import { useState } from "react";
import { styled } from "@mui/material/styles";
import { Box, CssBaseline } from "@mui/material";

// Theme
import theme from "../../../data/theme";
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import HeaderBase from "./components/HeaderBase";
import SideBarBase from "./components/SideBarBase";
import { useEffect } from "react";

export default function PersistentDrawerLeft() {

  // States
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);


  useEffect(() => {
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent); // Pode ajustar esse valor conforme necessário
    // console.log("mobile", mobile)
    setIsMobile(mobile);
    setOpen(!mobile)
  }, []);

  // useEffect(() => {
  //   console.log("open", open)
  // }, [open]);

  // work functions
  const handleDrawerToggle = () => { setOpen(!open) };

  return (
    <Box sx={{ width: "100%", height: "100vh" }}>
      <ThemeProvider theme={theme}>
        <Box sx={{ display: "flex" }}>
          <CssBaseline />

          <HeaderBase handleDrawerToggle={handleDrawerToggle} open={open} />

          <SideBarBase handleDrawerToggle={handleDrawerToggle} open={open} setOpen={setOpen} isMobile={isMobile}  />

          <Main open={open} sx={{minHeight: '100vh', backdropFilter: 'blur(50px)', bgcolor: '#F8F7FA', width: '100%', overflowX: 'hidden'}}>
            <DrawerHeader />
            <Box
              component="main"
              elevation={4}
              sx={{ flexGrow: 1, p: { xs: 0, sm: 4 }, marginX: { sx: 0, sm: 4 }, marginY: { sx: 0, sm: 1 }, bgcolor: "F8F7FA", minHeight: "85%", borderRadius: "15px", }}
            >
              <Outlet />
            </Box>
          </Main>
        </Box>
      </ThemeProvider>
    </Box>
  );
}


// Theme

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);


const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));
